/**
 * Get next submission index for a task.
 *
 * @param {Object} task
 * @param {Array} [task.submissions]
 * @returns {number}
 */
export function getNextSubmissionIndex(task) {
  if (!Array.isArray(task?.submissions)) return 0;
  return task.submissions.length;
}

/**
 * Normalize submissions list.
 *
 * @param {Object} task
 * @param {Array} [task.submissions]
 * @returns {Array}
 */
export function getTaskSubmissions(task) {
  return Array.isArray(task?.submissions) ? task.submissions : [];
}

/**
 * Compute submission grid layout.
 *
 * @param {Array} submissions
 * @returns {{
 *   rows: Array<Array<{ type: 'view'|'form', index: number }>>
 * }}
 */
export function buildSubmissionGrid(submissions) {
  const rows = [];

  if (!Array.isArray(submissions) || submissions.length === 0) {
    return { rows };
  }

  if (submissions.length === 1) {
    rows.push([{ type: 'view', index: 0 }]);
    return { rows };
  }

  // r0 + r1 side by side
  rows.push([
    { type: 'view', index: 0 },
    { type: 'view', index: 1 },
  ]);

  // r2+ one per row, single cell
  for (let i = 2; i < submissions.length; i++) {
    rows.push([{ type: 'view', index: i }]);
  }

  return { rows };
}
